export default __webpack_public_path__ + "static/media/mePhoto.f9f90035.jpg";